export abstract class SortComparisons {
  public static compare(a: any, b: any, descending: boolean = false): number {
    if (a > b) { return descending ? -1 : +1; }
    if (a < b) { return descending ? +1 : -1; }
    return 0;
  }

  public static compareBoolean(a: boolean, b: boolean, descending: boolean = false): number {
    return SortComparisons.compare(a, b, descending);
  }

  public static compareText(a: string, b: string, descending: boolean = false): number {
    return SortComparisons.compare(a.toLowerCase(), b.toLowerCase(), descending);
  }
}
